<template>
    <div>
        <yes_no
            key="CATEGORY_MODE"
            v-model="cur_categ.category_mode"
            :radio_options="category_modes"
            title="CATEGORY_MODE"
            @change="setCategMode"
        />

        <div
            v-if="cur_categ.category_mode === 'tag'"
            class="tag_mode mt-3"
        >
            <product_labels
                :items="getExtraItems('labels')"
                :hidden_groups="hidden_label_groups"
                @change_extra="set_on_change"
            />
        </div>
    </div>
</template>

<script>
import yes_no from "../../../../sys/radio/yes_no.vue";
import Product_labels from "../../../products/product/extra_components/product_labels.vue";

export default {
    name: "categ_mode",

    components: {
        Product_labels,
        yes_no
    },

    props: {
        categ: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            cur_categ: this.categ,

            category_modes: [
                { text: 'DEFAULT', value: 'default' },
                { text: 'TAG_MODE', value: 'tag' }
            ],
            hidden_label_groups: [
                'system',
            ],
        };
    },

    computed: {
        extra() {
            return Array.isArray(this.cur_categ.extra)
                ? this.cur_categ.extra
                : [];
        }
    },

    methods: {
        setCategMode(value) {
            this.$set(this.cur_categ, 'category_mode', value);
            this.emitChange();
        },

        getExtraGroup(type) {
            return this.extra.find(group => {
                return group && group.type === type;
            });
        },

        getExtraItems(type) {
            const group = this.getExtraGroup(type);

            return group && Array.isArray(group.items)
                ? group.items
                : [];
        },

        set_on_change(items, type) {
            const extra = Array.isArray(this.cur_categ.extra)
                ? [...this.cur_categ.extra]
                : [];

            const groupIndex = extra.findIndex(group => {
                return group && group.type === type;
            });

            const updatedGroup = {
                type,
                items: Array.isArray(items)
                    ? [...items]
                    : []
            };

            if (groupIndex >= 0) {
                this.$set(extra, groupIndex, updatedGroup);
            } else {
                extra.push(updatedGroup);
            }

            this.$set(this.cur_categ, 'extra', extra);

            this.emitChange();
        },

        emitChange() {
            this.$emit('on_change', this.cur_categ);
        }
    }
};
</script>

<style scoped>
.tag_mode {
    width: 100%;
}
</style>
